// src/components/ui/AuthRequiredModal.js
import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function AuthRequiredModal({ show, onClose }) {
    const navigate = useNavigate();

    if (!show) return null;

    const handleSignIn = () => {
        // Store that we came from extension page
        localStorage.setItem('redirectAfterLogin', '/profile?tab=resume');
        navigate('/signup');
    };

    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4"
            onClick={onClose}
        >
            <div
                className="bg-white rounded-2xl shadow-2xl max-w-md w-full overflow-hidden relative"
                onClick={e => e.stopPropagation()}
            >
                {/* Close button - simple X in top right */}
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors z-10 w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100"
                    aria-label="Close"
                >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>

                {/* Header */}
                <div className="px-8 pt-8 pb-6">
                    <h2 className="text-2xl font-bold text-[var(--forest-green)] font-poppins">
                        Sign In Required
                    </h2>
                </div>

                {/* Content */}
                <div className="px-8 pb-8">
                    <p className="text-[#4B5563] text-base mb-6 leading-relaxed">
                        Please sign in or create an account to save your resume profile and access all features.
                    </p>

                    {/* Features list */}
                    <div className="space-y-3 mb-8">
                        <div className="flex items-center gap-3">
                            <div className="w-6 h-6 rounded-full bg-[var(--pale-mint)] flex items-center justify-center flex-shrink-0">
                                <svg className="w-4 h-4 text-[var(--forest-green)]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" />
                                </svg>
                            </div>
                            <span className="text-[#4B5563] text-sm">Save your resume profile</span>
                        </div>
                        <div className="flex items-center gap-3">
                            <div className="w-6 h-6 rounded-full bg-[var(--pale-mint)] flex items-center justify-center flex-shrink-0">
                                <svg className="w-4 h-4 text-[var(--forest-green)]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" />
                                </svg>
                            </div>
                            <span className="text-[#4B5563] text-sm">Auto-fill job applications</span>
                        </div>
                        <div className="flex items-center gap-3">
                            <div className="w-6 h-6 rounded-full bg-[var(--pale-mint)] flex items-center justify-center flex-shrink-0">
                                <svg className="w-4 h-4 text-[var(--forest-green)]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" />
                                </svg>
                            </div>
                            <span className="text-[#4B5563] text-sm">Access from any device</span>
                        </div>
                    </div>

                    {/* Buttons */}
                    <div className="flex gap-3">
                        <button
                            onClick={onClose}
                            className="flex-1 px-5 py-3 border-2 border-[var(--forest-green)] text-[var(--forest-green)] font-semibold rounded-full hover:bg-[var(--pale-mint)] transition-colors text-sm"
                        >
                            Continue Editing
                        </button>
                        <button
                            onClick={handleSignIn}
                            className="flex-1 px-5 py-3 bg-[var(--forest-green)] text-white font-semibold rounded-full hover:bg-[var(--deep-teal)] transition-all shadow-md hover:shadow-lg transform hover:-translate-y-0.5 text-sm"
                        >
                            Sign In
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}